import { Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { IHeading } from "../models/type";

export interface Props {
  heading: IHeading;
}

const BrandHeading: React.FC<Props> = props => {
  const { heading } = props;
  return (
    <Stack justify="flex-start" align="center" spacing="20px" mt={14}>
      <Heading as={"h2"}>{heading.title}</Heading>
      <Text>{heading.content}</Text>
    </Stack>
  );
};

export default BrandHeading;
